var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.isActive
    },
    on: {
      close: _vm.closeDialog
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(_vm._s(_vm.title))]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-row",
              [
                !_vm.isModeDelete
                  ? _c(
                      "v-col",
                      {
                        staticClass: "body-1 pb-4",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.hint) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      sm: _vm.gridSize
                    }
                  },
                  [
                    _c("gg-select", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        outlined: "",
                        dense: "",
                        label: "Type",
                        disabled: _vm.loading || _vm.isModeDelete,
                        items: _vm.allowed_types,
                        name: "type",
                        "data-vv-as": "Record type",
                        "error-messages": _vm.errors.collect("type")
                      },
                      on: {
                        change: _vm.recordChanged
                      },
                      model: {
                        value: _vm.record_local.type,
                        callback: function callback($$v) {
                          _vm.$set(_vm.record_local, "type", $$v)
                        },
                        expression: "record_local.type"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      sm: _vm.gridSize
                    }
                  },
                  [
                    _c("gg-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        outlined: "",
                        dense: "",
                        label: "Name",
                        disabled: _vm.loading || _vm.isModeDelete,
                        name: "name",
                        "data-vv-as": "Name",
                        "error-messages": _vm.errors.collect("name")
                      },
                      on: {
                        input: _vm.recordChanged
                      },
                      model: {
                        value: _vm.record_local.name,
                        callback: function callback($$v) {
                          _vm.$set(_vm.record_local, "name", $$v)
                        },
                        expression: "record_local.name"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      sm: _vm.gridSize
                    }
                  },
                  [
                    _c("gg-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.addressValidation,
                          expression: "addressValidation"
                        }
                      ],
                      attrs: {
                        label: "Address",
                        disabled: _vm.loading || _vm.isModeDelete,
                        outlined: "",
                        dense: "",
                        name: "address",
                        "data-vv-as": "Address",
                        "error-messages": _vm.errors.collect("address")
                      },
                      on: {
                        input: _vm.recordChanged
                      },
                      model: {
                        value: _vm.record_local.address,
                        callback: function callback($$v) {
                          _vm.$set(_vm.record_local, "address", $$v)
                        },
                        expression: "record_local.address"
                      }
                    })
                  ],
                  1
                ),
                _vm.record.type === "MX"
                  ? _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          cols: "12",
                          sm: _vm.gridSize
                        }
                      },
                      [
                        _c("gg-text-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "between:0,1000",
                              expression: "'between:0,1000'"
                            }
                          ],
                          attrs: {
                            label: "Priority",
                            disabled: _vm.loading || _vm.isModeDelete,
                            outlined: "",
                            dense: "",
                            name: "mxpref",
                            "data-vv-as": "Priority",
                            "error-messages": _vm.errors.collect("mxpref")
                          },
                          on: {
                            input: _vm.recordChanged
                          },
                          model: {
                            value: _vm.record_local.mxpref,
                            callback: function callback($$v) {
                              _vm.$set(_vm.record_local, "mxpref", $$v)
                            },
                            expression: "record_local.mxpref"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.closeDialog
                }
              },
              [_vm._v(" Cancel ")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: function click($event) {
                    $event.preventDefault()
                    return _vm.submitFunction($event)
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.submitBtnText) + " ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }